// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"860":"mobileHome","953":"pcHome"}[chunkId] + "." + {"860":"9d2cd6d1","953":"0dabc1cf"}[chunkId] + ".css";
};